import { useCallback } from "react";

import { montarPayloadPdfAgendamento } from "../../utils/montarPayloadPdfAgendamento";

export default function useObterPayloadPdfOrcamento(dados) {
  return useCallback(() => {
    return montarPayloadPdfAgendamento({ tipoDocumento: "orcamento", ...dados });
  }, [dados]);
}
